import { usePopularCategories } from '../../entites/categories';
import {
  CategoryCard,
} from '@ui/category/category-card.tsx';

export const MainPopularCategories = () => {
  const { data } = usePopularCategories();
  return (
    <>
      <div className="lg:hidden snap-x no-scroll-bar pt-1 pb-3 -mx-4 px-4 flex flex-row flex-grow snap-mandatory gap-x-3 overflow-y-scroll">
        {data.map((item, index) => (<CategoryCard key={index} className='w-2/5' {...item} isSquare={false} />))}
      </div>

      <div className="hidden lg:grid grid-cols-4 gap-6 py-8 container max-w-7xl lg:mx-auto">
        {data.map((item, index) => (
          <CategoryCard key={index} {...item} isSquare={false} />
        ))}
      </div>
    </>
  );
};
